import { Group, Stack, Text, Title } from '@mantine/core';
import { NotificationsPage } from '@/features/notifications/NotificationsPage';
import { useClientOptions } from './api';

/** Notifications in the portal's own voice: the portal title block over the shared list. */
export function ClientNotificationsPage() {
  const options = useClientOptions();
  return (
    <NotificationsPage
      header={(markAll) => (
        <Group justify="space-between" align="flex-end" wrap="wrap" gap="md" mb="xl">
          <Stack gap={4}>
            <Title order={1} fz={{ base: 26, sm: 32 }} style={{ letterSpacing: '-0.015em' }}>
              Notifications
            </Title>
            <Text c="dimmed">{options.data?.company.name ? `${options.data.company.name} · updates from Makin on your dossiers` : ' '}</Text>
          </Stack>
          {markAll}
        </Group>
      )}
    />
  );
}
